export const ShowCardDataRoutes = {
    ROOT: "/show-card-data",
    SIGNING: "/show-card-data/signing",
    DETAILS: "/show-card-data/details",
    NEW_PHONE: "/show-card-data/new-phone",
    SUCCESS: "/show-card-data/success",
};



// WEBPACK FOOTER //
// ./src/components/showCardData/ShowCardDataRoutes.ts